import SupportPanel from '@/components/support/SupportPanel';
import { useAuth } from '@/lib/auth-context';

export function SponsorSupportTab() {
  const { profile } = useAuth();

  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-cocoa">Support tickets</h1>
        <p className="text-sm text-cocoa/70">
          Reach the Tower team for help with credits, payments, sponsorships, or anything else related to your account.
        </p>
      </header>

      <div className="rounded-2xl border border-sand/80 bg-white/80 p-4 shadow-soft">
        <SupportPanel
          roleLabel="Sponsor"
          defaultCategory="sponsor_support"
          contextMeta={{ surface: 'sponsor_portal', sponsor_id: (profile?.id as string) || undefined }}
        />
      </div>
    </div>
  );
}
